






















































































import { Component, Prop, Watch } from	'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIconTabDivider } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-tab';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwCountBlock } from '@libs-uuif/shared/sw-count-block';
const cssPrefix = 'status';
@Component({
  components: {
    SwIconTabDivider,
    SwIconButton,
    SwIcon,
    SwCountBlock,
  },
})
export default class Status extends SwExtendedVue {
  @Prop({ required: true })
  stats: any;
  @Prop({ required: true })
  isMaster: any;
  cssPrefix = cssPrefix;
  /* tslint:disable-next-line */
  /* eslint-disable-line */
  status: any =  [];
  @Watch('stats')
  check() { // tslint:disable-line
    const newStatus: any = [];
    // this.stats.mssps = '15';
    // this.stats.ccEndpoints = '5';
    // this.stats.CMSpooledLicense = '4';
    // this.stats.cloudEdge = '2';
    // this.stats.tznsa = '3';
    // && this.isMaster
    if (this.stats.mssps && this.stats.mssps !== '' && this.stats.mssps !== '0' && this.isMaster) {
      newStatus.push({ count: Number(this.stats.mssps), label: this.$t('tenantMgmt.status.mssp'), iconName: 'manage-security-services-security-as-a-Services' });
    }
    if (this.stats.tenants && this.stats.tenants !== '' && this.stats.tenants !== '0') {
      newStatus.push({ count: Number(this.stats.tenants), label: this.$t('tenantMgmt.status.tenant'), iconName: 'service-msw' });
    }
    if (this.stats.ccEndpoints && this.stats.ccEndpoints !== '' && this.stats.ccEndpoints !== '0') {
      newStatus.push({ count: Number(this.stats.ccEndpoints), label: this.$t('tenantMgmt.status.cc'), iconName: 'service-captureclient' });
    }
    if (this.stats.ccmdrEndpoints && this.stats.ccmdrEndpoints !== '' && this.stats.ccmdrEndpoints !== '0') {
      newStatus.push({ count: Number(this.stats.ccmdrEndpoints), label: this.$t('tenantMgmt.status.ccMdr'), iconSrc: 'mdr' });
    }
    if (this.stats.casUsers && this.stats.casUsers !== '' && this.stats.casUsers !== '0') {
      newStatus.push({ count: Number(this.stats.casUsers), label: this.$t('tenantMgmt.status.cas'), iconName: 'service-cas' });
    }
    if (this.stats.nsvFirewalls && this.stats.nsvFirewalls !== '' && this.stats.nsvFirewalls !== '0') {
      newStatus.push({ count: Number(this.stats.nsvFirewalls), label: this.$t('tenantMgmt.status.nsv'), iconName: 'ns-v' });
    }
    if (this.stats.CMSpooledLicense && this.stats.CMSpooledLicense !== '' && this.stats.CMSpooledLicense !== '0') {
      newStatus.push({ count: Number(this.stats.CMSpooledLicense), label: this.$t('tenantMgmt.status.cms'), iconSrc: 'cms' });
    }
    if (this.stats.cloudEdge && this.stats.cloudEdge !== '' && this.stats.cloudEdge !== '0') {
      newStatus.push({ count: Number(this.stats.cloudEdge), label: this.$t('tenantMgmt.status.ce'), iconName: 'SonicExpress' });
    }
    if (this.stats.cseUsers && this.stats.cseUsers !== '' && this.stats.cseUsers !== '0') {
      newStatus.push({ count: Number(this.stats.cseUsers), label: this.$t('tenantMgmt.status.cse'), iconName: 'SonicExpress' });
    }
    if (this.stats.hes && this.stats.hes !== '' && this.stats.hes !== '0') {
      newStatus.push({ count: Number(this.stats.hes), label: this.$t('tenantMgmt.status.hes'), iconName: 'email-security-email-security' });
    }
    if (this.stats.sslvpnusers && this.stats.sslvpnusers !== '' && this.stats.sslvpnusers !== '0' && !this.stats.sslvpnusers.includes('-')) {
      newStatus.push({ count: this.stats.sslvpnusers, label: this.$t('tenantMgmt.status.sslvpn'), iconName: 'ssl-vpn' });
    }
    if (this.stats.tznsa && this.stats.tznsa !== '' && this.stats.tznsa !== '0' && !this.stats.tznsa.includes('-')) {
      newStatus.push({ count: Number(this.stats.tznsa), label: this.$t('tenantMgmt.status.fs'), iconName: 'service-fwmanagement' });
    }
    if (this.stats.tz80s && this.stats.tz80s !== '' && this.stats.tz80s !== '0') {
      newStatus.push({ count: Number(this.stats.tz80s), label: this.$t('tenantMgmt.status.tz80'), iconName: 'service-fwmanagement' });
    }
    if (this.stats.sonicSwitches && this.stats.sonicSwitches !== '' && this.stats.sonicSwitches !== '0') {
      newStatus.push({ count: Number(this.stats.sonicSwitches), label: this.$t('tenantMgmt.status.switch'), iconName: 'SW-Switch' });
    }
    if (this.stats.sonicWaves && this.stats.sonicWaves !== '' && this.stats.sonicWaves !== '0') {
      newStatus.push({ count: Number(this.stats.sonicWaves), label: this.$t('tenantMgmt.status.wave'), iconName: 'ap-simple' });
    }
    this.status = newStatus;
    // const jsonObject = this.status.map(JSON.stringify);
    // console.log(jsonObject);
    // const uniqueSet = new Set(jsonObject);
    // const uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    // this.status = [...tempStatus]
  }
  get dividerColor() {
    return '#FFA500';
  }
}
